var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.90898 0.327512C1.47226 -0.109187 0.76421 -0.109168 0.327512 0.327552C-0.109187 0.764273 -0.109168 1.47232 0.327552 1.90902L11.4185 12.9994L0.329972 24.0874C-0.106747 24.5241 -0.106767 25.2321 0.329932 25.6689C0.766629 26.1056 1.47468 26.1056 1.9114 25.6689L13 14.5808L24.0887 25.6689C24.5254 26.1056 25.2334 26.1056 25.6701 25.6689C26.1068 25.2321 26.1068 24.5241 25.6701 24.0874L14.5815 12.9994L25.6725 1.90902C26.1092 1.47232 26.1092 0.764273 25.6726 0.327552C25.2359 -0.109168 24.5278 -0.109187 24.0911 0.327512L13 11.418L1.90898 0.327512Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon_cross.9f01bd05ebd2958f3e52cec5304f9c3d.svg";
export { ForwardRef as ReactComponent };